import { state } from '@/store/linkAssetEquipment/state';
import { getters } from '@/store/linkAssetEquipment/getters';
import { actions } from '@/store/linkAssetEquipment/actions';
import { mutations } from '@/store/linkAssetEquipment/mutations';

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export { state, getters, mutations, actions };
